// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const InstallLeadPage = () => import('@/modules/installs/views/InstallLeadPage')
const InstallDashboard  = () => import('@/modules/installs/views/InstallDashboard')

const InstallUnassignedList = () => import('@/modules/installs/views/InstallUnassignedList');
const InstallTerminalDeploymentList = () => import('@/modules/installs/views/InstallTerminalDeploymentList');
const InstallTerminalSetupList = () => import('@/modules/installs/views/InstallTerminalSetupList');
const InstallCallbackList = () => import('@/modules/installs/views/InstallCallbackList');
const InstallOrdersWithoutCallList = () => import('@/modules/installs/views/InstallOrdersWithoutCallList');
const PendingInstallList = () => import('@/modules/installs/views/PendingInstallList');
const InstallCashAdvanceList = () => import('@/modules/installs/views/InstallCashAdvanceList');
const InstallPendingTransactionList = () => import('@/modules/installs/views/InstallPendingTransactionList');
const InstallPendingTxWithoutCallList = () => import('@/modules/installs/views/InstallPendingTxWithoutCallList');
const InstallEscalatedManagerList = () => import('@/modules/installs/views/InstallEscalatedManagerList');
const InstallAddEquipmentList = () => import('@/modules/installs/views/InstallAddEquipmentList');
const InstallCompleteList = () => import('@/modules/installs/views/InstallCompleteList');

const NewInstallDashboard  = () => import('@/modules/installs/views/NewInstallDashboard')

// Taliup Tabs
const TaliupRegisterSetupList = () => import('@/modules/installs/views/TaliupRegisterSetupList');
const TaliupRegisterPendingInstallList = () => import('@/modules/installs/views/TaliupRegisterPendingInstallList');
const TaliupRegisterCatalogBuildList = () => import('@/modules/installs/views/TaliupRegisterCatalogBuildList');

const InstallHouseReturnsList = () => import('@/modules/installs/views/InstallHouseReturnsList');

var routes = [
    {
        path: '/installs',
        redirect: '/installs/dashboard',
        name: 'Installs',
        component: DefaultContainer,
        children: [
            {
				path: '/installs',
                name: 'InstallLeadPage',
				redirect: '/installs/new-dashboard',
                component: InstallLeadPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'new-dashboard',
						name: 'NewInstallDashboard',
						component: NewInstallDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'new-dashboard',
							role_filter: 'installation_rep',
						},

					},
					{
						path: 'dashboard',
						name: 'InstallDashboard',
						component: InstallDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'dashboard',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'unassigned',
						name: 'InstallUnassignedList',
						component: InstallUnassignedList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'unassigned',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'terminal-deployment',
						name: 'InstallTerminalDeploymentList',
						component: InstallTerminalDeploymentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'terminal-deployment',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'terminal-setup',
						name: 'InstallTerminalSetupList',
						component: InstallTerminalSetupList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'terminal-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'callbacks',
						name: 'InstallCallbackList',
						component: InstallCallbackList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'callbacks',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'orders-without-call',
						name: 'InstallOrdersWithoutCallList',
						component: InstallOrdersWithoutCallList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'orders-without-call',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'pending-install',
						name: 'PendingInstallList',
						component: PendingInstallList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'pending-install',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'cash-advance',
						name: 'InstallCashAdvanceList',
						component: InstallCashAdvanceList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'cash-advance',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'pending-transactions',
						name: 'InstallPendingTransactionList',
						component: InstallPendingTransactionList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'pending-transactions',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'pending-tx-without-call',
						name: 'InstallPendingTxWithoutCallList',
						component: InstallPendingTxWithoutCallList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'pending-tx-without-call',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'escalated-manager',
						name: 'InstallEscalatedManagerList',
						component: InstallEscalatedManagerList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'escalated-manager',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'add-equipment',
						name: 'InstallAddEquipmentList',
						component: InstallAddEquipmentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'add-equipment',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'complete',
						name: 'InstallCompleteList',
						component: InstallCompleteList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'complete',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'taliup-register-setup',
						name: 'TaliupRegisterSetupList',
						component: TaliupRegisterSetupList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'taliup-register-setup',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'taliup-register-pending-install',
						name: 'TaliupRegisterPendingInstallList',
						component: TaliupRegisterPendingInstallList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'taliup-register-pending-install',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'taliup-register-catalog-build',
						name: 'TaliupRegisterCatalogBuildList',
						component: TaliupRegisterCatalogBuildList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'taliup-register-catalog-build',
							role_filter: 'installation_rep',
						},
					},
					{
						path: 'house-returns',
						name: 'InstallHouseReturnsList',
						component: InstallHouseReturnsList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'house-returns',
							role_filter: 'installation_rep',
						},
					},
				]
            },
        ]
    },
];

export default routes;
